import React from 'react';

import { StyledRequiredSpan, StyledLabel, StyledInput } from '@/components/Form/styles';
import { StyledFlexColumn } from '@/layout/FlexLayout';

import type { InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  onValueChange?: (value: string) => void;
  label?: string;
  required?: boolean;
}

function Input({ onValueChange, label, required, ...HTMLProps }: InputProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onValueChange) {
      onValueChange(event.target.value);
    }
  };

  return (
    <StyledFlexColumn>
      {label && (
        <StyledLabel>
          {label} {required && <StyledRequiredSpan>*</StyledRequiredSpan>}
        </StyledLabel>
      )}
      <StyledInput {...HTMLProps} onChange={handleChange} />
    </StyledFlexColumn>
  );
}

export { Input };
